// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"9898ee4c","148":"4f9ec289","166":"683339ef","182":"37c2ea11","279":"86428623","501":"1de21bbe","516":"d4e6e5a7","565":"b3b76888","704":"0d4a0c38","740":"1ae7dbed","824":"02a2df1b","885":"c29f806d","966":"08204283"}[chunkId] + ".chunk.js";
};